'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.entityHasSameId = entityHasSameId;

var _fields = require('./fields');

function entityHasSameId(options) {
    let internalId = _fields.fields.id,
        tempId = _fields.fields.tempId;
    let id = options.id;

    let leftId;
    let rightId;
    return (left, right) => {
        if (left === right) {
            return true;
        }
        if (left && right) {
            leftId = left[internalId];
            rightId = right[internalId];
            if (leftId && leftId === rightId) {
                return true;
            }
            if (id) {
                leftId = left[id];
                rightId = right[id];
                if (leftId && leftId === rightId) {
                    return true;
                }
            }
            leftId = left[tempId];
            rightId = right[tempId];
            if (leftId && leftId === rightId) {
                return true;
            }
        }
        return false;
    };
}
//# sourceMappingURL=entityHasSameId.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/resource/entityHasSameId.js